<script setup lang="ts">
import type { HTMLAttributes, TextareaHTMLAttributes } from 'vue'
import { useVModel } from '@vueuse/core'
import { BASE_CLASS, BASE_INVALID_CLASS } from './variant'

const props = defineProps<{
  class?: HTMLAttributes['class']
  defaultValue?: string | number | null
  modelValue?: string | number | null
  invalid?: boolean
  rows?: TextareaHTMLAttributes['rows']
}>()

const emits = defineEmits<{
  (e: 'update:modelValue', payload: string | number | null): void
}>()

const modelValue = useVModel(props, 'modelValue', emits, {
  passive: true,
  defaultValue: props.defaultValue
})

const textInputRef = ref<HTMLTextAreaElement | null>(null)

defineExpose({
  textInputRef,
  focus: () => {
    textInputRef.value?.focus?.()
  }
})
</script>

<template>
  <textarea
    ref="textInputRef"
    v-model="modelValue"
    :rows="rows || 5"
    :class="
      cn(
        BASE_CLASS,
        {
          [BASE_INVALID_CLASS]: props.invalid
        },
        props.class
      )
    "
  />
</template>
